import { LogoUser } from "@/shared/components/common/icons";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import React, { useState, useEffect, use } from "react";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import moment from "jalali-moment";
import AccessAlarmsIcon from "@mui/icons-material/AccessAlarms";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import BedtimeOutlinedIcon from "@mui/icons-material/BedtimeOutlined";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import { useNavigate, useParams } from "react-router";
import { fetchCountUserMessage } from "@/api/user/home";
import { fetchCountMerchantMessage } from "@/api/merchant/request.get";

type HeaderShareProps = {
  timerElement?: React.ReactNode;
  logoHeader?: React.ReactNode;
  setOpenDrawer?: any;
};

const HeaderShare = (props: HeaderShareProps) => {
  const timer = moment(new Date()).locale("fa").format("HH:mm");
  const date = moment(new Date()).locale("fa").format("YYYY/MM/DD");
  const { timerElement, logoHeader, setOpenDrawer } = props;

  const [loading, setLoading] = useState(false);
  const [totalMessage, setTotalMessage] = useState<number>(0);

  const navigate = useNavigate();
  const roleEnter = window.localStorage.getItem("roleEnter");

  const loadMessages = async () => {
    setLoading(true);
    try {
      const apiCall =
        roleEnter === "user"
          ? fetchCountUserMessage
          : fetchCountMerchantMessage;
      const res = await apiCall();
      setTotalMessage(res.unread ?? 0);
    } catch (err) {
      console.error("Error fetching messages:", err);
    } finally {
      setLoading(false);
    }
  };

  // Load messages once on component mount
  useEffect(() => {
    loadMessages();
  }, []); // only once
  const route = useParams();
  console.log("route", route);
  return (
    <StackKit
      direction="row"
      alignItems="center"
      className="w-full px-3 md:px-6 lg:px-12 py-2 md:py-3 lg:py-5 flex justify-between"
    >
      {/* Drawer Menu Mobile */}
      <BoxKit display={{ sm: "block", md: "block", lg: "none" }}>
        <IconButton onClick={() => setOpenDrawer(true)}>
          <MenuIcon sx={{ color: "#fff" }} />
        </IconButton>
      </BoxKit>

      {/* Center: Date, Time, Icons */}
      <StackKit
        direction="row"
        alignItems="center"
        gap={2}
        className="flex-wrap text-gray-400 w-full md:w-auto justify-between"
      >
        <div className="hidden sm:flex">
          <StackKit
            direction="row"
            justifyContent="between"
            alignItems="center"
            className="bg-[#FDFDFD] text-gray-100 w-full sm:w-[250px] h-[55px] px-3 rounded-xl justify-between items-center"
          >
            <StackKit
              direction="row"
              alignItems="center"
              gap={1}
              color={"#000000"}
              fontWeight={"400"}
            >
              <span>{toPersianNumber(timer)}</span>
              <AccessAlarmsIcon className="text-[#000000] text-md" />
            </StackKit>

            <StackKit
              direction="row"
              alignItems="center"
              gap={1}
              color={"#000000"}
            >
              <span>{toPersianNumber(date)}</span>
              <CalendarMonthIcon className="text-[#000000] text-md" />
            </StackKit>

            {timerElement}
          </StackKit>
        </div>

        {/* Icons */}
        <div className="flex gap-2 sm:gap-3">
          {[NotificationsNoneIcon, BedtimeOutlinedIcon, SettingsSuggestOutlinedIcon].map(
            (Icon, i) => (
              <BoxKit
                key={i}
                className={`relative bg-[#fff] w-[45px] h-[45px] flex justify-center items-center rounded-full cursor-pointer ${
                  Icon === NotificationsNoneIcon ? "" : "hidden md:flex"
                }`}
              >
                {/* Badge only on notification icon */}
                {Icon === NotificationsNoneIcon && totalMessage > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                    {toPersianNumber(totalMessage)}
                  </span>
                )}

              <Icon
                className="text-[#000000]"
                onClick={() => {
                  if (Icon === NotificationsNoneIcon) navigate("/list-message");
                }}
              />
            </BoxKit>
          ))}
        </div>
      </StackKit>

      {/* Left: Logo */}
      <BoxKit className="items-center justify-end ml-auto pt-8">
        {logoHeader || <LogoUser />}
      </BoxKit>
    </StackKit>
  );
};

export default HeaderShare;
